import { inject, Injectable } from '@angular/core';
import { CustomerModel } from '@libs/account/models';
import { CustomersState } from './state/';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private readonly customerState: CustomersState = inject(CustomersState);

  public updateCustomer(data: Partial<CustomerModel>): Promise<void> {
    return this.customerState.updateCustomer(data);
  }
}
